import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["option"]
  static values = { formId: String, noSubmit: Boolean, filterName: String }

  initialize() {
    this._debouncedOptionSelect = debounce(this.optionSelect.bind(this), 1500, false)
  }

  debouncedOptionSelect(event) {
    this._debouncedOptionSelect(event)
  }

  updateBooleanSwitch(event) {
    const checkbox = event.target;
    const labelId = checkbox.dataset.labelId;
    const labelEl = document.getElementById(labelId);
    if (labelEl) {
      labelEl.textContent = checkbox.checked ? "true" : "false";
    }
    // Compute aggsName from the labelId (expects format: [aggsName]_label_boolean)
    const aggsName = labelId.replace('_label_boolean', '');
    const hiddenKey = document.getElementById(`${aggsName}_hidden_key`);
    const hiddenComparator = document.getElementById(`${aggsName}_hidden_comparator`);
    if (hiddenKey) { hiddenKey.disabled = !checkbox.checked; }
    if (hiddenComparator) { hiddenComparator.disabled = !checkbox.checked; }
  }

  optionSelect(event) {
    if (event.target.type !== 'checkbox') { return }

    let selectedOptions = []
    let optionEls = this.element.querySelectorAll('input[type="checkbox"]')
    if (optionEls.length === 0) { return }

    let name = this.hasFilterNameValue ? this.filterNameValue : null
    if (!name) {
      let namedCheckbox = Array.from(optionEls).find(el => el.name)
      name = namedCheckbox ? namedCheckbox.name : optionEls[0].name
    }
    for (let option of optionEls) {
      if (option.checked) {
        selectedOptions.push(option.value)
      }
    }
    this.dispatch(
      'filter-options',
      { detail: { name: name, options: selectedOptions, noSubmit: this.noSubmitValue } }
    );
    let form;
    if (this.hasFormIdValue && this.formIdValue) {
      form = document.getElementById(this.formIdValue);
    } else {
      form = this.element.closest("form");
    }
    if (form && form.tagName === "FORM" && !this.noSubmitValue) {
      form.requestSubmit();
    }
  }
}
